module.exports = __webpack_public_path__ + "img/arrow-up-square.f9f03448.svg";